import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { EnsureUserMutation as EnsureUserMutationType, EnsureUserMutationVariables } from "gql/types/mutations/EnsureUserMutation";

const text = gql`mutation EnsureUserMutation {
	ensureUser {
		deviceToken
	}
}
`;

const EnsureUserMutation: IOperation<EnsureUserMutationType, EnsureUserMutationVariables> = { text } as any;

export default EnsureUserMutation;
